import React from "react";
import { Pagination } from "react-bootstrap";

const CustomPagination = ({ pagination, handlePageChange }) => {
  if (!pagination) return null;

  const { currentPage, totalPages } = pagination;

  const getPageItems = () => {
    const pageItems = [];
    const maxVisiblePages = 7;
    const half = Math.floor(maxVisiblePages / 2);

    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, currentPage + half);

    if (currentPage <= half) {
      end = Math.min(totalPages, maxVisiblePages);
    } else if (currentPage + half > totalPages) {
      start = Math.max(1, totalPages - maxVisiblePages + 1);
    }

    // Show first page & ellipsis
    if (start > 1) {
      pageItems.push(
        <Pagination.Item key={1} onClick={() => handlePageChange(1)}>1</Pagination.Item>
      );
      if (start > 2) {
        pageItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
    }

    // Show visible page range
    for (let i = start; i <= end; i++) {
      pageItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    // Show ellipsis & last page
    if (end < totalPages) {
      if (end < totalPages - 1) {
        pageItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }
      pageItems.push(
        <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    return pageItems;
  };

  return (
    <Pagination className="mt-4 justify-content-center">
      <Pagination.First disabled={currentPage === 1} onClick={() => handlePageChange(1)} />
      <Pagination.Prev disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} />
      {getPageItems()}
      <Pagination.Next disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)} />
      <Pagination.Last disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)} />
    </Pagination>
  );
};

export default CustomPagination;
